
import Vue from "vue";
import { PROMO_CODES } from "@/store/promoCodes";

export default Vue.extend({
  props: {
    isLoading: {
      type: Boolean,
      default: false
    }
  }
});
